import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <div className="hero-typewriter">
      <Typewriter
        options={{
          strings: [
            "Software Engineer",
            "HCI Designer",
            "AI Researcher",
            "Lifelong Learner",
          ],
          autoStart: true,
          loop: true,
          deleteSpeed: 40,
          delay: 60,
        }}
      />
    </div>
  );
}

export default Type;
